import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a booking journey dialog.
 *
 * @extends {DialogComponent}
 */
class BookingJourneyDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('booking-journey-dialog')) {
  customElements.define('booking-journey-dialog', BookingJourneyDialog);
}
